import { render } from "./UserTalents.vue?vue&type=template&id=60b399be"
import script from "./UserTalents.vue?vue&type=script&lang=js"
export * from "./UserTalents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__